import styled, { css } from 'styled-components';
import { userSelectNone } from '../../../../../styles/mixins';

const hideStyles = css`
  opacity: 0 !important;
  cursor: default;
  pointer-events: none;
`;

const overlayStyles = css`
  &.arrow-left {
    margin-left: 12px;
  }
  &.arrow-right {
    margin-right: 12px;
  }
`;

const hoverStyles = css`
  /* Default state: invisible arrows */
  &.arrow-left,
  &.arrow-right {
    opacity: 0;
  }

  &:hover {
    transform: scale(1.1);
    opacity: 1 !important;

    img {
      transform: scale(0.9);
    }
  }

  &:focus-visible {
    transform: scale(1.1);
    opacity: 1 !important;
    outline: 2px solid #0066cc;
    outline-offset: 2px;
  }
`;

const transparencyStyles = css`
  opacity: 0.6;
`;

export const ArrowContainer = styled.button<{ hideArrow: boolean; isOverlay: boolean; useTransparency: boolean }>`
  min-width: 30px;
  height: 30px;
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
  pointer-events: auto;
  border: none;
  padding: 0;
  font: inherit;

  ${({ hideArrow }) => (hideArrow ? hideStyles : hoverStyles)};
  ${({ useTransparency }) => useTransparency && transparencyStyles};

  &.arrow-left {
    position: absolute;
    left: 0;
    border-radius: 16px;
    margin-left: 16px;
    img {
      transform: rotate(180deg);
    }
  }

  &.arrow-right {
    position: absolute;
    right: 0;
    margin-right: 16px;
    border-radius: 16px;
  }

  img {
    ${userSelectNone}
    polyline {
      stroke: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
    }
  }

  ${({ isOverlay }) => isOverlay && overlayStyles};
`;
